var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"colorSwitch",on:{"click":function($event){return _vm.switchClicked()}}},[_c('div',{staticClass:"switcher",class:{'selected' : _vm.dark === true}})])}
var staticRenderFns = []

export { render, staticRenderFns }